import { useRef, useEffect, useState } from 'react'

import appConfig from '~/config/app'

interface playcanvasMessage {
  data: { state: string }
  origin: string
}

function InteractiveShapeViewer({ shape }: { shape: string }): React.ReactElement {
  const [isLoaded, setIsLoaded] = useState(false)
  const interactiveShapeViewerFrameRef = useRef<HTMLIFrameElement>(null)
  const interactiveShapeViewerUrl = appConfig.playcanvas.interactiveShapeViewer

  useEffect(() => {
    window.addEventListener('message', (event: playcanvasMessage) => {
      if (event.origin === interactiveShapeViewerUrl.origin && event.data.state === 'ready') {
        setIsLoaded(true)
      }
    })

    if (isLoaded) {
      const postMessage = interactiveShapeViewerFrameRef.current?.contentWindow
      if (postMessage) {
        postMessage.postMessage(shape, interactiveShapeViewerUrl.origin)
      }
    }

    return () => {
      window.removeEventListener('message', (event: playcanvasMessage) => {
        if (event.origin === interactiveShapeViewerUrl.origin && event.data.state === 'ready') {
          setIsLoaded(true)
        }
      })
    }
  }, [isLoaded, shape, interactiveShapeViewerUrl.origin])

  return (
    <iframe
      className="select-none w-full min-h-xs -z-1"
      ref={interactiveShapeViewerFrameRef}
      src={interactiveShapeViewerUrl.href}
    />
  )
}

export default InteractiveShapeViewer
